export default __webpack_public_path__ + "static/media/Team.ac71fcb2.svg";